export default ({
    "data": {
        "client": "demo",
        "playerOptions": {
            "playbackRates": false,
            "autoplay": false,
            "height": "500",
            "controls": true,
            "techOrder": ["html5"],
            "sourceOrder": true,
            "flash": {
                "hls": {
                    "withCredentials": false
                }
            },
            "html5": {
                "hls": {
                    "withCredentials": false
                }
            }
            ,
            "sources": [{
                "withCredentials": false,
                "type": "",
                "src": "",
                "selected": false
            }],
            "poster": "",
        },
        "rmOptions": [],
        "playListOptions": null,
        "colorOptions": "250,149,43",
        "communicationOptions": 0,
        "subscriptionOptions": [],
        "surveyOptions": false,
        "commentsOptions": false,
        "searchOptions": false
    }
});



// WEBPACK FOOTER //
// ./src/core/info/info.js